import styled from 'styled-components'

const Topo = styled.div`
  background-color: ${(props) => props.theme.colors.secundaria};
  color: ${(props) => props.theme.colors.primary};
  text-align: center;
  padding: 24px 0;
`
export default Topo
